const requiredAttributes = {
  MS: ["acc", "agi", "bal", "jum", "pac", "sta", "str", "agg", "ant", "bra", "cmp", "cnt", "dec", "fla", "otb", "pos", "tea", "vis", "wor", "cro", "dri", "fin", "fir", "hea", "lon", "mar", "pas", "tck", "tec"],
  DM: ["acc", "agi", "bal", "jum", "pac", "sta", "str", "agg", "ant", "bra", "cmp", "cnt", "dec", "pos", "tea", "wor", "hea", "mar", "tck", "pas"],
  D: ["acc", "agi", "bal", "pac", "ant", "dec", "pos", "tea", "cmp", "cnt", "pas"],
  S: ["str", "jum", "acc", "agi", "bal", "pac", "agg", "bra", "wor", "ant", "dec", "tea", "otb", "hea", "tec", "fir"],
  DMS: ["fla", "vis", "cro", "dri", "fin", "fir", "hea", "lon", "mar", "pas", "tck", "tec"],
  G: ["thr", "kic", "pas"],
}

const playersToRatePerPosition = {
  G: 3,
  D: 6,
  M: 7,
  S: 5,
};


const numberOfPlayersToRate = (positions) => {
  const result = Array.from(positions).reduce((sum, char) => {
    const value = playersToRatePerPosition[char] || 0;
    return sum + value;
  }, 0);

  return result;
}


const playersToIncludeInRating = (positions, allPlayers, key) => {
  const positionPlayers = allPlayers.filter(player => {
    return (positions.includes("D") && player.defender) ||
           (positions.includes("M") && player.midfielder) ||
           (positions.includes("S") && player.striker) ||
           (positions.includes("G") && player.goalkeeper);
  })
  const playersWithAttribute = positionPlayers.filter(player => player[key] !== undefined);
  const n = numberOfPlayersToRate(positions);

  return playersWithAttribute.slice(0, n);
}


const calculateWeightedAverage = (group) => {
  // Calculate the sum and max score in the group
  const sum = group.reduce((acc, score) => acc + score, 0);
  const maxScore = Math.max(...group);

  // Normalize scores and use them as weights
  const normalizedWeights = group.map(score => (score / sum) * maxScore);

  // Calculate the weighted average
  const weightedSum = group.reduce((acc, score, index) => acc + score * normalizedWeights[index], 0);
  const totalWeight = normalizedWeights.reduce((acc, weight) => acc + weight, 0);
  const weightedAverage = totalWeight > 0 ? weightedSum / totalWeight : 0;

  return weightedAverage;
}


export const rankAttributes = (playerData) => {
  const uniqueClubs = [...new Set(playerData.map(obj => obj.club))];

  // calculate averages
  const resultObject = uniqueClubs.reduce((acc, club) => {
    acc[club] = {};

    const clubPlayers = playerData.filter(player => player.club === club);
    const firstTeamPlayers = clubPlayers.sort((a, b) => b.wage - a.wage).slice(0, 26);
    
    for (const [position, attributeKeys] of Object.entries(requiredAttributes)) {
      for (const key of attributeKeys) {
        const playersToRate = playersToIncludeInRating(position, firstTeamPlayers, key);
        const weightedAverage = calculateWeightedAverage(playersToRate.map(player => player[key]));

        if (acc[club][position] === undefined) acc[club][position] = {};
        acc[club][position][key] = {
          average: weightedAverage,
          rank: 0,
        };
      }
    }

    return acc;
  }, {});

  // calculate ranks
  for (const [position, attributeKeys] of Object.entries(requiredAttributes)) {
    for (const attributeKey of attributeKeys) {
      uniqueClubs.sort((clubA, clubB) => {
        return resultObject[clubB][position][attributeKey].average - resultObject[clubA][position][attributeKey].average;
      });
      uniqueClubs.forEach((clubName, i) => {
        resultObject[clubName][position][attributeKey].rank = i + 1;
        resultObject[clubName][position][attributeKey].rating = Math.round((uniqueClubs.length - i - 1) / (uniqueClubs.length - 1) * 100);
      });
    }
  }

  return resultObject;
};
